export class ExtendedMap<K, V> extends Map<K, V> {
  toArray() {
    return Array.from(this.values());
  }
}
